export default {
  getPerson: (state) => state.getPerson,
  rating: (state) => state.rating,
  getRating: (state) => state.person.rating,
  person: (state) => state.person,
  cachedPerson: (state) => state.cachedPerson,
  personEmail: (state) => state.personEmail,
  cachedPersonByEmail: (state) => state.cachedPersonByEmail,
  persons: (state) => state.persons,
  cachedPersons: (state) => state.cachedPersons,
};
